import { LDProvider } from 'launchdarkly-react-client-sdk';
import { FunctionComponent, PropsWithChildren, use } from 'react';
import { browserName, deviceType } from 'react-device-detect';
import { AuthContext } from '../context/auth/context';

type Props = {
  sdkKey: string;
};

export const LaunchDarklyProvider: FunctionComponent<
  PropsWithChildren<Props>
> = ({ children, sdkKey }) => {
  const authContext = use(AuthContext);

  const contextKey = authContext?.userId || undefined;

  const segmentUserId =
    // eslint-disable-next-line react-x/purity -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
    localStorage.getItem('ajs_anonymous_id')?.replaceAll('"', '') ||
    // eslint-disable-next-line react-x/purity -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
    localStorage.getItem('ajs_user_id')?.replaceAll('"', '') ||
    '';

  return (
    <LDProvider
      clientSideID={sdkKey}
      context={{
        kind: 'user',
        anonymous: !authContext?.isLoggedIn,
        key: contextKey,
        custom: {
          location: window.location.href,
          browserName: browserName,
          deviceType: deviceType,
          segmentId: segmentUserId,
        },
      }}
    >
      {children}
    </LDProvider>
  );
};
